import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const { data } = await axios.get("v1/body-worn/recordings", { params });

      if (!data.success) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    async getLinks(_, recordingId) {
      const { data } = await axios.get(`v1/body-worn/recordings/${recordingId}/links`);

      if (!data.success) {
        throw new Error("links");
      }

      return data.data;
    },
  },
};
